export const EMAIL = "slcpersonnel@gmx.es";

export const ADDRESS = {
  line1: "Patricio Sanz 1365, Int. 201",
  line2: "Col. Piedad Narvarte, C.P. 03000",
  city: "Ciudad de México, México",
};

export const MAP_URL =
  "https://www.google.com/maps/search/?api=1&query=" +
  encodeURIComponent("Patricio Sanz 1365, Piedad Narvarte, 03000 Ciudad de México");

export const CONTENT = {
  es: {
    nav: { about: "Nosotros", services: "Servicios", contact: "Contacto", cta: "Escríbenos" },
    hero: {
      eyebrow: "Ciudad de México — Servicios corporativos",
      lines: ["Personas,", "materiales", "y confianza."],
      sub: "S&LC Personnel Management SA de CV. Prestación de servicios de recursos humanos y venta y compra de materiales en general.",
      copy: "Copiar correo",
      copied: "Copiado",
      scroll: "Desliza",
    },
    marquee: ["Recursos Humanos", "Compra de Materiales", "Venta de Materiales", "Gestión de Personal", "Suministro General", "Ciudad de México"],
    about: {
      label: "01 — Nosotros",
      title: "Una sola empresa para el talento que impulsa tu operación y los materiales que la sostienen.",
      body: "En S&LC Personnel Management unimos dos necesidades esenciales de cualquier organización: contar con las personas adecuadas y con los materiales necesarios. Trabajamos de forma cercana, ordenada y transparente para que cada cliente se concentre en lo que mejor sabe hacer.",
      pillars: [
        { k: "Cercanía", v: "Atención directa y personalizada desde nuestras oficinas en la colonia Piedad Narvarte." },
        { k: "Orden", v: "Procesos claros en cada servicio de personal y en cada operación de compra-venta." },
        { k: "Confianza", v: "Relaciones de largo plazo basadas en el cumplimiento y la transparencia." },
      ],
    },
    services: {
      label: "02 — Servicios",
      title: "Dos especialidades, un mismo estándar.",
      items: [
        {
          id: "hr",
          n: "I",
          title: "Servicios de Recursos Humanos",
          body: "Prestación de servicios de recursos humanos adaptados a las necesidades de cada empresa.",
          bullets: ["Reclutamiento y selección", "Administración de personal", "Gestión de nómina", "Asesoría en capital humano"],
          img: "/img/team.jpg",
        },
        {
          id: "materials",
          n: "II",
          title: "Venta y Compra de Materiales",
          body: "Venta y compra de materiales en general para empresas y proyectos de distintos sectores.",
          bullets: ["Compra de materiales en general", "Venta y suministro", "Búsqueda de proveedores", "Cotizaciones a la medida"],
          img: "/img/materials.jpg",
        },
      ],
    },
    contact: {
      label: "03 — Contacto",
      title: "Hablemos.",
      body: "Escríbenos para solicitar información o una cotización. Te responderemos a la brevedad.",
      emailLabel: "Correo electrónico",
      addressLabel: "Domicilio",
      map: "Ver en el mapa",
    },
    footer: { rights: "Todos los derechos reservados.", top: "Volver arriba" },
  },
  en: {
    nav: { about: "About", services: "Services", contact: "Contact", cta: "Write to us" },
    hero: {
      eyebrow: "Mexico City — Corporate services",
      lines: ["People,", "materials", "and trust."],
      sub: "S&LC Personnel Management SA de CV. Human resources services and the buying and selling of general materials.",
      copy: "Copy email",
      copied: "Copied",
      scroll: "Scroll",
    },
    marquee: ["Human Resources", "Materials Buying", "Materials Selling", "Personnel Management", "General Supply", "Mexico City"],
    about: {
      label: "01 — About",
      title: "One company for the talent that drives your operation and the materials that sustain it.",
      body: "At S&LC Personnel Management we bring together two essential needs of every organization: having the right people and the right materials. We work closely, orderly and transparently so each client can focus on what they do best.",
      pillars: [
        { k: "Closeness", v: "Direct, personal attention from our offices in Colonia Piedad Narvarte." },
        { k: "Order", v: "Clear processes in every staffing service and every buying or selling operation." },
        { k: "Trust", v: "Long-term relationships built on reliability and transparency." },
      ],
    },
    services: {
      label: "02 — Services",
      title: "Two specialties, one standard.",
      items: [
        {
          id: "hr",
          n: "I",
          title: "Human Resources Services",
          body: "Human resources services tailored to the needs of each company.",
          bullets: ["Recruitment & selection", "Personnel administration", "Payroll management", "Human capital advisory"],
          img: "/img/team.jpg",
        },
        {
          id: "materials",
          n: "II",
          title: "Buying & Selling of Materials",
          body: "Buying and selling of general materials for companies and projects across industries.",
          bullets: ["General materials purchasing", "Sales & supply", "Supplier sourcing", "Tailored quotes"],
          img: "/img/materials.jpg",
        },
      ],
    },
    contact: {
      label: "03 — Contact",
      title: "Let's talk.",
      body: "Write to us to request information or a quote. We'll get back to you shortly.",
      emailLabel: "Email",
      addressLabel: "Address",
      map: "View on map",
    },
    footer: { rights: "All rights reserved.", top: "Back to top" },
  },
};
